var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01702 -8.14215e-07C7.26855 -7.92226e-07 7.52004 0.096037 7.7118 0.287709L13.7463 6.32224C14.1301 6.70612 14.1301 7.3285 13.7463 7.71221C13.3626 8.09593 12.7403 8.09593 12.3564 7.71221L7.01702 2.37252L1.67761 7.71203C1.29374 8.09574 0.671545 8.09574 0.28786 7.71203C-0.0961974 7.32831 -0.0961974 6.70593 0.28786 6.32206L6.32224 0.287522C6.5141 0.0958191 6.76559 -8.36196e-07 7.01702 -8.14215e-07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowDown);
export default __webpack_public_path__ + "static/media/whiteArrowDown.1da3b4a54150b6dccad7278f79b65dd7.svg";
export { ForwardRef as ReactComponent };